// Company Information from Firm Profile
// Updated: October 2025

export const companyInfo = {
  name: 'EXCI-MAA',
  fullName: 'EXPERTS COMPTABLES INTERNATIONAUX – MAA',
  tagline: 'Management, Audit & Advisory',
  subtitle: 'Chartered Professional Accountants',
  website: 'www.exci-maa.com',
  phone: '+250 787 77 99 65',
  
  mission: {
    title: 'Our Mission',
    description: 'Our mission is to support clients based in Africa towards financial performance. We propose effective solutions, adapted to the needs of the company and responding to the specific context of the African continent. Our multi-disciplinary and multicultural team offers complete service and includes real added value for the customer at a fair budget.',
  },

  background: {
    title: 'Background',
    description: 'Created by professionals and experts in the field of auditing, accounting, taxation, business development, management information system, law, etc. proven in Canada, the United States of America, France, U.K. and Africa.',
  },

  keysToSuccess: [
    {
      id: 1,
      title: 'Listening and understanding our clients\' needs',
      icon: '👂',
    },
    {
      id: 2,
      title: 'Taking into account the customer\'s specific environment',
      icon: '🌍',
    },
    {
      id: 3,
      title: 'Clients\' proximity',
      icon: '🤝',
    },
    {
      id: 4,
      title: 'Compliance with international/national professional standards',
      icon: '✓',
    },
    {
      id: 5,
      title: 'Quality as a core value',
      icon: '⭐',
    },
  ],

  languages: ['French', 'English', 'Spanish', 'German'],

  professionalAccreditations: [
    'The Order of Chartered Accountants of Quebec, Canada',
    'The Order of Chartered Accountants of Ontario, Canada',
    'The Institute of Certified Public Accountants of Rwanda (ICPAR)',
    'The Order of Professional Accountants Burundi (OPC)',
    'The Order of Accountants of Ohio, USA',
    'The Order of ACCA of Great Britain (ACCA)',
    'The Order of Chartered Accountants of Cameroon (ONECCA)',
    'The Order of Chartered Accountants of Paris (Iles de France), France',
    'Certification by COSUMAF',
    'The Order of Chartered Accountants of CEMAC (Cameroon, Congo, Gabon, Tchad, Equatorial Guinea, Central African Republic)',
    'ACCA Approved Employer',
  ],

  services: [
    {
      id: 1,
      category: 'Audit & Assurance',
      items: [
        'Control of Financial Information',
        'Statutory audits',
        'Audit of company accounts, combined and consolidated accounts',
        'Contractual audits',
        'Audit of NGO projects',
        'Forecast accounts',
        'Audit of oil costs',
        'Internal control',
      ],
    },
    {
      id: 2,
      category: 'Tax & Legal',
      items: [
        'Tax arbitration',
        'Tax Advice & Tax Compliance',
        'Transfer prices',
        'Legal advice: Constitution, OHADA Update, Audit, Legal Secretariat',
        'Fiscal Law: Due diligence',
        'Social Law: Recruitment, Employment Contract, Paycheck Declarations, Audit',
      ],
    },
    {
      id: 3,
      category: 'Advisory & Consulting',
      items: [
        'Analytics and Operations Optimization',
        'Business plans and Strategy',
        'Audits and management consultancy',
        'Transactions-Financial Mutations-Legal assistance',
        'Governance and risk management',
        'Bankruptcy Advice and Corporate Reorganization',
      ],
    },
    {
      id: 4,
      category: 'Technology & Systems',
      items: [
        'Digital Business & Integrated Management System (SAP, ORACLE, MAGNITUDE, SAGE X3)',
        'HARDCAT-Fixed Asset Management (Asset Management with Bar Codes)',
        'ERP Implementation, SAP/IT Solutions',
      ],
    },
    {
      id: 5,
      category: 'Accounting & Finance',
      items: [
        'Accounting and Tax assistance',
        'Annual or projected financial statements',
        'Setting up an accounting organization',
        'Management Software Bookkeeping',
        'Declaration of taxes',
        'Business plan',
        'Credit Portfolio Analysis',
        'Rating',
        'Evaluations',
      ],
    },
    {
      id: 6,
      category: 'Training',
      items: [
        'International and local taxation systems',
        'Transfer pricing',
        'Financial statements and year-end procedures',
        'Management of fixed assets and purchases',
        'International treaties and agreements',
        'Group accounting and consolidation of Financial Statements',
        'Insurance Financial Statements and Reporting Templates',
        'International Financial Reporting Standards (IFRS)',
        'Public Sector Accounting (IPSAS)',
        'Internal control Fraud Detection and Prevention',
        'Business development and project management',
        'Financial management',
        'Taxation in the digital economy',
      ],
    },
    {
      id: 7,
      category: 'Specialized Services',
      items: [
        'Insurance experience Center',
        'Facility Management & Mycodebar',
        'Facilities Management',
        'Electronic management of stock and assets by bar codes',
      ],
    },
  ],

  clientSectors: [
    { id: 1, name: 'Mining', icon: '⛏️' },
    { id: 2, name: 'Betting, Gaming, Casinos', icon: '🎰' },
    { id: 3, name: 'Multinational institutions', icon: '🌐' },
    { id: 4, name: 'Government institutions', icon: '🏛️' },
    { id: 5, name: 'Insurance companies', icon: '🛡️' },
    { id: 6, name: 'Oil and gas', icon: '⛽' },
    { id: 7, name: 'Hospitals', icon: '🏥' },
    { id: 8, name: 'Real Estate', icon: '🏢' },
    { id: 9, name: 'Sports and media', icon: '📺' },
    { id: 10, name: 'NGO', icon: '🤝' },
    { id: 11, name: 'Banks', icon: '🏦' },
    { id: 12, name: 'Private sector companies/institutions', icon: '💼' },
    { id: 13, name: 'Educational institution', icon: '🎓' },
    { id: 14, name: 'Electoral bodies', icon: '🗳️' },
    { id: 15, name: 'Public markets', icon: '🏪' },
    { id: 16, name: 'Projects funded by international organizations (EU, UNHCR, USAID, World Bank, etc.)', icon: '🌍' },
    { id: 17, name: 'Media', icon: '📰' },
  ],

  clientReferences: {
    oilAndGas: [
      'Le consortium pétrolier EEPCI',
      'Exxon Mobil-ESSO',
      'Petronas',
      'Chevron',
      'Schlumberger',
      'Baker Hughes',
      'Brunel Energy',
      'Encana',
      'PSN',
      'PERENCO',
      'TOTAL',
      'WING WAH',
      'SOCCO',
    ],
    mining: ['GPB (Graz prom)', 'AvionGold'],
    banks: ['SGT', 'Ecobank', 'Orabank', 'CBT', 'BCC', 'BSIC', 'UBA', 'BGFI', 'LCB', 'Société Générale', 'Credit du Congo'],
    hotels: ['Novotel', 'Méridien', 'Hilton Pnr', 'Akwa Palace', 'Radisson Congo'],
    telecom: ['Ericsson AB', 'Millicom Tigo', 'Airtel', 'Tech Mahindra', 'SOTEL', 'SOTELMA'],
    health: ['EuropAssistance', 'International SOS', 'Government Hospitals'],
    brewery: ['BRALICO', 'MAYO', 'COOPT', 'BRASCO'],
    others: ['CFAO Motors', 'Laborex', 'CST', 'Necotrans', 'Scet Tunisie'],
    ngos: ['World Bank (BM)', 'AFD', 'BAD', 'EU', 'UNHCR', 'USAID'],
  },

  trainingExperiences: [
    'International and local taxation systems',
    'Transfer pricing',
    'Financial statements and year-end procedures',
    'Management of fixed assets and purchases',
    'International treaties and agreements',
    'Group accounting and consolidation of Financial Statements',
    'Insurance Financial Statements and Reporting Templates',
    'International Financial Reporting Standards',
    'Public Sector Accounting (IPSAS)',
    'Internal control Fraud Detection and Prevention Funds',
    'Business development and project management',
    'Financial management',
    'Taxation in the digital economy',
    'International IFRS Standards',
  ],

  auditExperience: [
    'Development Banks (UBA, Ecobank, BGFI, LCB, Société Générale, Credit du Congo, etc.)',
    'Hospitals',
    'Education',
    'Oil & Gas, Mining (TOTAL, WING WAH, SOCCO etc)',
    'Hospitality sector',
    'Project funded by international organization (EU, UNHCR, World Bank, USAID, etc.)',
    'Constructions',
    'Government institutions (various governmental levels)',
    'Educational institutions',
    'Electoral Bodies, Parliament',
    'Government contracts (PPP)',
    'Commercial companies',
    'Brewery industry (BRALICO, MAYO, COOPT, BRASCO, etc.)',
  ],
};

export const keyTeamMembers = [
  {
    id: 'pierre-kemeni',
    name: 'Pierre KEMENI',
    title: 'Partner, Managing Director',
    qualifications: ['MBA', 'CPA', 'CGA', 'FCAA'],
    highlights: [
      'Partner, Managing Director at EXCI-MAA Group',
      'COSUMAF Licensed',
      'Chartered Accountant & Statutory Auditor',
      'Registered with ICPAR (Rwanda)',
      'Registered with ONECCA (Cameroon)',
      'Partner, CPA Alliance Mac Firm - Montreal Canada',
      'Registered on the Boards of Chartered Accountants (CPA Canada, CPA Quebec, CPA Ontario & Great Britain)',
      'Judicial expert at the Pointe-Noire Court of Appeal',
      'Specialist-Consultant, Management - Banking Sector',
      'Former Engagement Director (consultant) - Deloitte Toronto',
      'Specialist in SYSCOHADA and Account conversion',
      'Senior International Consultant and Trainer',
    ],
  },
  {
    id: 'paul-tchamake',
    name: 'Paul TCHAMAKE',
    title: 'Partner - International Tax Specialist',
    qualifications: ['Ms', 'CPA (USA)'],
    highlights: [
      'Certified Chartered Accountant American and French Regime',
      'Order of Certified Chartered Accountants of Ile-de-France, Paris France',
      'ICPAR member and Practitioner',
      'International Tax Specialist, ASC 740 (US GAAP Standards)',
      'More than 15 years of international financial and tax reporting practice',
      'Experience with Big 4 firms',
    ],
  },
];
